import { TranslateService } from '@ngx-translate/core';
import { format, getYear, isAfter, isBefore, isSameDay } from 'date-fns';

import {
  ComercialNote,
  MonthOption,
  SinisterThread,
  TypeUserEnum,
  User
} from '@core/models';

export function copyObject<T>(object: T): T {
  return JSON.parse(JSON.stringify(object)) as T;
}

export const tableSize: number[] = [25, 50, 100];

export function getWriterName(
  users: User[],
  userId: string,
  message: ComercialNote | SinisterThread,
  translate: TranslateService
): string {
  const user = getUser(users, message.userId);
  if (isIncofiso(user)) {
    return translate.instant('utils.get_writer_name.EBI_SUPPORT');
  } else {
    const loggedUser = getUser(users, userId);
    if (loggedUser?.id === message.userId) {
      return translate.instant('utils.get_writer_name.ME');
    } else if (isIncofiso(loggedUser)) {
      return translate.instant('utils.get_writer_name.CLIENT');
    } else if (user?.firstname) {
      return `${user?.firstname} ${user?.surname1}`;
    } else {
      return '';
    }
  }
}

export function getUser(users: User[], userId: string): User {
  return users?.find((u: User) => u.id === userId);
}

function isIncofiso(user: User): boolean {
  return user?.userType === TypeUserEnum.INCOFISA_ADMINISTRATIVE;
}

export function compare(
  a: number | Date | string,
  b: number | Date | string,
  isAsc: boolean
): number {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}

export function formatDateToService(date: Date): string | undefined {
  if (!date) {
    return undefined;
  }

  return format(date, 'dd-MM-yyyy');
}

export function isBetween(
  initDate: Date,
  endDate: Date,
  compareDate: Date
): boolean {
  return (
    (isAfter(compareDate, initDate) || isSameDay(compareDate, initDate)) &&
    (isBefore(compareDate, endDate) || isSameDay(compareDate, endDate))
  );
}

export function fileSizeOk(file: File): boolean {
  if (file) {
    const maxSize = 10 * 1024 * 1024;
    return file?.size <= maxSize;
  } else {
    return true;
  }
}

export function userFullName(user: User): string {
  if (!user) {
    return '';
  }
  let fullname = `${user.firstname} ${user.surname1}`;
  if (user.surname2) {
    fullname += ` ${user.surname2}`;
  }
  return fullname;
}

export const monthsArray: MonthOption[] = [
  { label: 'enums.months.jan', value: 1 },
  { label: 'enums.months.feb', value: 2 },
  { label: 'enums.months.mar', value: 3 },
  { label: 'enums.months.apr', value: 4 },
  { label: 'enums.months.may', value: 5 },
  { label: 'enums.months.jun', value: 6 },
  { label: 'enums.months.jul', value: 7 },
  { label: 'enums.months.aug', value: 8 },
  { label: 'enums.months.sep', value: 9 },
  { label: 'enums.months.oct', value: 10 },
  { label: 'enums.months.nov', value: 11 },
  { label: 'enums.months.dec', value: 12 }
];

export function getYearsArray(): number[] {
  const years: number[] = [];
  for (let year = 2021; year <= getYear(new Date()); year++) {
    years.push(year);
  }
  return years;
}

export function include(field: string, valueToCheck: string): boolean {
  return field?.toLowerCase().includes(valueToCheck.toLowerCase());
}
